import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getSidebar, buildPath } from '../OAD/shared/navConfig';
import { iconeBoutonPage } from './iconesNavigation';


/**
 * Frame Figma "Side_bar_parametres".
 *
 * Deux parties :
 *  - en haut, la navigation de niveau 3 ("bouton navigation intra-page"),
 *    générée depuis navConfig.js — boutons à icône vers les pages soeurs ;
 *  - en dessous, les filtres propres à la page (année, culture, semis,
 *    Groupe_scenarios_clim...), passés en children par chaque page.
 *
 * Une page sans niveau 3 (Impacts globaux, les deux optimisations) n'affiche
 * que ses filtres ; une page sans filtre n'affiche que sa navigation.
 */
export default function SidebarParametres({ niveau1, niveau2, niveau3, idExploit, children }) {
  const navigate = useNavigate();
  const entrees = getSidebar(niveau1, niveau2);

  return (
    <aside className="sidebar-parametres">
      {entrees && (
        <nav className="sidebar-nav-intra">
          {entrees.map((entree) => {
            const actif = entree.key === niveau3;
            const src = iconeBoutonPage(entree.icon);
            return (
              <button
                key={entree.key}
                type="button"
                className={`sidebar-nav-bouton${actif ? ' sidebar-nav-bouton-actif' : ''}`}
                onClick={() =>
                  navigate(buildPath(niveau1, niveau2, entree.key), { state: { idExploit } })
                }
                disabled={actif}
              >
                {src && <img src={src} alt="" />}
                <span>{entree.label}</span>
              </button>
            );
          })}
        </nav>
      )}

      {children && <div className="sidebar-filtres">{children}</div>}
    </aside>
  );
}
